import { NavigateFunction, useNavigate } from 'react-router-dom';
import FormHeader from '../../components/forms/FormHeader';

const PasswordResetSuccess = () => {
  const navigate: NavigateFunction = useNavigate();
  return (
    <>
      <FormHeader
        title={`Mot de passe réinitialisé avec succès`}
        subTitle={`Si vous souhaitez retourner à la page de connexion, veuillez cliquer ci-dessous.`}
      />
      <div onClick={() => navigate(`/login`)} className='text-green-secondary mt-3 cursor-pointer text-center font-bold hover:underline'>
        Retour à la page de connexion
      </div>
    </>
  );
};

export default PasswordResetSuccess;
